module.exports = __webpack_public_path__ + "static/media/super_engineer_create.6ed7b927.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/super_engineer_create.svg
// module id = 477
// module chunks = 0